export default __webpack_public_path__ + "static/images/paper-trading.70e0dac5.png";